import { Component, ElementRef, ViewChild } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LanguageService } from '../../../Services/languageService';
import { Subscription } from 'rxjs';
import { mdlBindInfo_MotorCancel_Req } from '../../../Models/mdlBindInfo_MotorCancel_Req';
import { mdlBindInfo_MotorCancel_Res } from '../../../Models/mdlBindInfo_MotorCancel_Res';
import { userService } from '../../../Services/userService';
import { policyModel } from '../../../Models/policyModel';
import { mdlOTPReq } from '../../../Models/mdlOTPReq';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import swal from 'sweetalert2';
import { OtpVerifyReq } from '../../../Models/OtpVerifyReq';
import { Router } from '@angular/router';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'Motor_Cancellation',
  templateUrl: './Motor_Cancellation.html',
  styleUrls: ['./Motor_Cancellation.css']
})
export class Motor_Cancellation {

  public isShowLoading: boolean = false;
  public Lng: string;
  public Reason: string;
  public Cancellation_Reason: string;
  public LngSubscription: Subscription;
  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;
  public agreeTerms: boolean = false;
  public InsuredNameAr: string;
  public InsuredNameEn: string;
  public ShowInsuredName_En: boolean = false;
  public ShowInsuredName_Ar: boolean = false;
  public isLockFields: boolean = false;
  public showOTP: boolean = false;
  public isShowTimer: boolean = false;
  public isResendShow: boolean = false;
  public timeLeft: number = 180;
  public interval;
  public OTP: string;
  public isSubmitted: boolean = false;
  public objBindInfoReq: mdlBindInfo_MotorCancel_Req = new mdlBindInfo_MotorCancel_Req();
  public objBindInfoRes: mdlBindInfo_MotorCancel_Res = new mdlBindInfo_MotorCancel_Res();
  public objPolicy: policyModel = new policyModel();
  public objOTPReq: mdlOTPReq = new mdlOTPReq();
  public objMotorStatusMdl: MotorStatusMdl = new MotorStatusMdl();
  public objOtpVerifyReq: OtpVerifyReq = new OtpVerifyReq();
  public ArabicTextFirstLetter: string;
  public ArabicTextSecondLetter: string;
  public ArabicTextThirdLetter: string;
  public EnglishTextFirstLetter: string;
  public EnglishTextSecondLetter: string;
  public EnglishTextThirdLetter: string;
  public declaration: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;

  public headers = new HttpHeaders();

  constructor(public Translate: TranslateService, private EncriptService: motorProposalService, private router: Router, public url: restURL, private http: HttpClient, private userinfo: userService, private lngService: LanguageService) {

    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng; });
    //this.objPolicy = JSON.parse(sessionStorage.getItem("MotorCancelObj"));
    this.objPolicy = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("MotorCancelObj")));

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    } else {
      this.Lng = "en";
    }

    this.GetBindInfo();
  }







  //<<<<<<<<<<<<<GetBindInfo START>>>>>>>>>>>>>>>>>>>>
  GetBindInfo() {
    this.isShowLoading = true;
    this.objBindInfoReq.PolicyNo = this.objPolicy.PolicyNo;
    this.objBindInfoReq.RegNo = this.objPolicy.regNo;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objBindInfoReq));

    //this.http.post<mdlBindInfo_MotorCancel_Res>(this.url.baseURL + "/Motor_Cancellation/BindInfo_Motor_Cancellation", this.objBindInfoReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/BindInfo_Motor_Cancellation", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.objBindInfoRes = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.objBindInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      //this.objBindInfoRes.RefundAmount

      if (this.objBindInfoRes.PlateTextEng != null && this.objBindInfoRes.PlateTextAr != null) {
        this.ArabicTextFirstLetter = this.objBindInfoRes.PlateTextAr.charAt(0);
        this.ArabicTextSecondLetter = this.objBindInfoRes.PlateTextAr.charAt(2);
        this.ArabicTextThirdLetter = this.objBindInfoRes.PlateTextAr.charAt(4);
        this.EnglishTextFirstLetter = this.objBindInfoRes.PlateTextEng.charAt(0);
        this.EnglishTextSecondLetter = this.objBindInfoRes.PlateTextEng.charAt(2);
        this.EnglishTextThirdLetter = this.objBindInfoRes.PlateTextEng.charAt(4);
      }

      if (this.objBindInfoRes.StatusCode == "F") {
        swal(this.Lng == "en" ? this.objBindInfoRes.StatusDescEng : this.objBindInfoRes.StatusDescAr);
        this.router.navigate(['/NewDashboard/Policy']);
        return;
      }
      if (this.objBindInfoRes.InsuredName_Ar == '') {
        this.ShowInsuredName_Ar = true;
      }
      if (this.objBindInfoRes.InsuredName_En == '') {
        this.ShowInsuredName_En = true;
      }
      this.setBankCode(this.objBindInfoRes.IBAN2);

      // this.objBindInfoRes.AttachmentId = this.objBindInfoRes.PolicyNo.replace("/", "-");
      // this.objBindInfoRes.AttachmentId=this.objBindInfoRes.AttachmentId.replace("/", "-");

      this.objBindInfoRes.AttachmentId = this.objBindInfoRes.PolicyNo.split('/').join('-');

    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });
  }
  //<<<<<<<<<<<<<GetBindInfo END>>>>>>>>>>>>>>>>>>>>

  //<<<<<<<<<<<<<CHECK IBAN START>>>>>>>>>>>>>>>>>>>>>>>>>
  btnSubmit(valid) {
    this.isSubmitted = true;
    
    // if (this.objBindInfoRes.IDCopyImage == null || this.objBindInfoRes.IBANCopyImage == null) {
    //   swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //   return;
    // }

    // if (this.objBindInfoRes.CancellationReason == 1) {
    //   if (this.objBindInfoRes.AltInsuranceCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }
    // if (this.objBindInfoRes.CancellationReason == 2) {
    //   if (this.objBindInfoRes.NewOwnerIsthCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }
    // if (this.objBindInfoRes.CancellationReason == 3) {
    //   if (this.objBindInfoRes.ProofOfVehDisposeCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }

    if (!this.objBindInfoRes.AccountName || this.objBindInfoRes.AccountName.length === 0) {
      swal("Please Enter Bank Account Holder name");
      return;
    }

    if (!this.agreeTerms) {

      this.Lng == "ar" ? swal("الرجاء الموافقة على الشروط والأحكام") : swal("Please Agree Terms and Conditions");
      return;
    }
    if (!this.declaration) {
      this.Lng == "ar" ? swal("الرجاء الموافقة على الإقرار والتعهد") : swal("Please Agree Declaration");
      return;
    }
    if (valid) {

      if (this.objBindInfoRes.IBAN1 != null && this.objBindInfoRes.IBAN2 != null && this.objBindInfoRes.IBAN3 != null && this.objBindInfoRes.IBAN4 != null && this.objBindInfoRes.IBAN5 != null && this.objBindInfoRes.IBAN6 != null) {
        this.objBindInfoRes.IBANNo = this.objBindInfoRes.IBAN1 + this.objBindInfoRes.IBAN2 + this.objBindInfoRes.IBAN3 + this.objBindInfoRes.IBAN4 + this.objBindInfoRes.IBAN5 + this.objBindInfoRes.IBAN6;
        this.objBindInfoRes.IBANNo = "SA" + this.objBindInfoRes.IBANNo;
      }
      else {
        this.Lng == "ar" ? swal("الرجاء إدخال رقم الايبان للمتابعة") : swal("Please Enter IBAN Number to proceed");
        return;
      }
      if (this.objBindInfoRes.IBANNo.length != 24) {
        this.Lng == "ar" ? swal(" رقم الايبان 24 رقم فقط ") : swal("IBAN Number must be 24 digits");
        return;
      }
      if ((this.objBindInfoRes.Bankname.length == 0 || this.objBindInfoRes.Bankname == null || this.objBindInfoRes.Bankname == "00")) {
        this.Lng == "ar" ? swal("اسم البنك غير صحيح ") : swal("Invalid Bank Name");
        return;
      }
      this.SendOTP();
      // this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/CheckIBAN", this.objBindInfoRes, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //   this.objMotorStatusMdl = result;
      //   if (this.objMotorStatusMdl.StatusCode != "S") {
      //     swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
      //     return;
      //   }
      //   else{
      //     this.SendOTP();
      //   }
      // }, (error) => {
      //   this.isShowLoading = false;
      //   this.userinfo.checkTokenStatus(error);
      // });


    }
  }
  //<<<<<<<<<<<<<CHECK IBAN END>>>>>>>>>>>>>>>>>>>>>>>>>



  //<<<<<<<<<<<<<Submit Cancellation START>>>>>>>>>>>>>>>>>>>>
  SendOTP() {
    // this.objOTPReq.MobileNo = this.objBindInfoRes.MobileNo;
    // this.objOTPReq.RegNo = Number(this.objBindInfoReq.RegNo);
    // this.objOTPReq.Lng = this.Lng;
    this.objBindInfoRes.Lng = this.Lng;

    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objBindInfoRes));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/SendOTP_Motor_Cancellation", this.objBindInfoRes, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/SendOTP_Motor_Cancellation", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.objMotorStatusMdl = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End



      swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
      if (this.objMotorStatusMdl.StatusCode == "S") {
        this.isLockFields = true;
        this.showOTP = true;
        this.showOTPTimer();
      }
    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);

    });

  }
  //<<<<<<<<<<<<<Submit Cancellation END>>>>>>>>>>>>>>>>>>>>





  //<<<<<<<<<<<<<showOTPTimer OTP START>>>>>>>>>>>>>>>>>>>>
  showOTPTimer() {
    this.isShowTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.timeLeft = 0;
        this.isResendShow = true;
      } else {
        this.timeLeft = 180;
      }
    }, 1000)
  }
  //<<<<<<<<<<<<<showOTPTimer OTP END>>>>>>>>>>>>>>>>>>>>



  //<<<<<<<<<<<<<VERIFY OTP START>>>>>>>>>>>>>>>>>>>>
  VerifyOTP() {
    if (this.OTP == null) {
      this.Lng == "ar" ? swal("برجاء إدخال رمز التفعيل") : swal("Please Enter Valid OTP");
      return;
    }
    this.objOtpVerifyReq.OTP = this.OTP;
    this.objOtpVerifyReq.RegNo = Number(this.objBindInfoReq.RegNo);
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objOtpVerifyReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/Verify_Motor_Cancellation", this.objOtpVerifyReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/Verify_Motor_Cancellation", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.objMotorStatusMdl = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      if (this.objMotorStatusMdl.StatusCode == "S") {
        this.showOTP = false;
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.OTP = "";
        this.isShowTimer = false;
        this.SubmitCancellationRequest();
      }
      else {
        swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
      }

    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });
  }
  //<<<<<<<<<<<<<VERIFY OTP END>>>>>>>>>>>>>>>>>>>>



  //<<<<<<<<<<<<<RESEND OTP START>>>>>>>>>>>>>>>>>>>>
  ResendOTP() {
    this.objOTPReq.MobileNo = this.objBindInfoRes.MobileNo;
    this.objOTPReq.RegNo = Number(this.objBindInfoReq.RegNo);
    this.objOTPReq.Lng = this.Lng;
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objOTPReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/ReSendOTP_Motor_Cancellation", this.objOTPReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/ReSendOTP_Motor_Cancellation", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.objMotorStatusMdl = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End



      swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
      if (this.objMotorStatusMdl.StatusCode == "S") {
        this.isLockFields = true;
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.isResendShow = false;
        this.showOTPTimer();
        this.showOTP = true;
      }
    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });
  }
  //<<<<<<<<<<<<<RESEND OTP END>>>>>>>>>>>>>>>>>>>>

  //<<<<<<<<<<<<<IBAN START>>>>>>>>>>>>>>>>>>>>

  iban1Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }


  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        let bankCode: string = event.substring(0, 2);
        if (this.objBindInfoRes.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          this.objBindInfoRes.Bankname = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          this.objBindInfoRes.Bankname = "";
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }
    }
  }

  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }

  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }

  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }
  //<<<<<<<<<<<<<IBAN END>>>>>>>>>>>>>>>>>>>>




  //<<<<<<<<<<<<<SetBankCode START>>>>>>>>>>>>>>>>>>>>
  setBankCode(IBAN) {

    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      if (IBAN.length == 4) {
        let bankCode: string = IBAN.substring(0, 2);
        if (this.objBindInfoRes.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          this.objBindInfoRes.Bankname = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          this.objBindInfoRes.Bankname = "";
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }
    }
  }
  //<<<<<<<<<<<<<SetBankCode START>>>>>>>>>>>>>>>>>>>>



  //<<<<<<<<<<<<<SUBMIT CANCELLATION REQUEST START>>>>>>>>>>>>>>

  SubmitCancellationRequest() {
    this.isShowLoading = true
    if (this.objBindInfoRes.IBAN1 != null && this.objBindInfoRes.IBAN2 != null && this.objBindInfoRes.IBAN3 != null && this.objBindInfoRes.IBAN4 != null && this.objBindInfoRes.IBAN5 != null && this.objBindInfoRes.IBAN6 != null) {
      this.objBindInfoRes.IBANNo = this.objBindInfoRes.IBAN1 + this.objBindInfoRes.IBAN2 + this.objBindInfoRes.IBAN3 + this.objBindInfoRes.IBAN4 + this.objBindInfoRes.IBAN5 + this.objBindInfoRes.IBAN6;
      this.objBindInfoRes.IBANNo = "SA" + this.objBindInfoRes.IBANNo;
    }


    // if (this.objBindInfoRes.IDCopyImage == null || this.objBindInfoRes.IBANCopyImage == null) {
    //   swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //   return;
    // }

    // if (this.objBindInfoRes.CancellationReason == 1) {
    //   if (this.objBindInfoRes.AltInsuranceCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }
    // if (this.objBindInfoRes.CancellationReason == 2) {
    //   if (this.objBindInfoRes.NewOwnerIsthCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }
    // if (this.objBindInfoRes.CancellationReason == 3) {
    //   if (this.objBindInfoRes.ProofOfVehDisposeCopyImage == null) {
    //     swal(this.Translate.instant("Please upload all related documents to proceed further"))
    //     return;
    //   }
    // }


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objBindInfoRes));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/SubmitCancellationRequest", this.objBindInfoRes, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/SubmitCancellationRequest", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.objMotorStatusMdl = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      if (this.objMotorStatusMdl.StatusCode == "F") {
        this.isLockFields = true;
      }
      swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);

    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });
  }
  //<<<<<<<<<<<<<SUBMIT CANCELLATION REQUEST END>>>>>>>>>>>>>>


  //<<<<<<<<<<<<<Validate Special Characters START>>>>>>>>>>>>>>

  ValidateSpecialCharacters(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  //<<<<<<<<<<<<<Validate Special Characters END>>>>>>>>>>>>>>


  ShowDeclaration() {
    try {
      let stHTML: string;
      let Title: string;
      if (this.Lng == "en") {
        Title = "Declaration";
        stHTML = "<h5 class='declarationtext'>I declare that the above information in this application is true and correct and includes all the information required in according to the relevant terms, regulations, and fundamentals. As I have read all the terms and conditions and obligations arising from the cancellation of my insurance policy, I hereby request the Gulf General Cooperative Insurance Company (GGCIC) to cancel my document and leave the Company fully responsible for any current or future claims relating to the vehicle.<h5>"
      } else {
        Title = "اقرار وتعهد"
        stHTML = "<h5 class='declarationtext'>أقر أنا مقدم الطلب أعلاه بأن المعلومات المذكورة أعلاه في هذا الطلب هي حقيقة وصحيحة والمشتملة على كافة المعلومات المتطلبة وفق الانظمة والتشريعات ذات العلاقة وأساسيات التأمين وأحكامها. وكما أني قد إطلعت على كافة الشروط والأحكام والإلتزامات التي تترتب على إلغاء وثيقة التأمين الخاصة بي وبهذا أطالب المجموعةالشركة الخليجية العامة للتأمين التعاونيبإلغاء الوثيقة الخاصة بي وأخلي مسؤولية الشركة تماماً تجاه أي مطالبة حالية أو مستقبلية متعلقة بالمركبة.</h5>"
      }
      swal({
        title: Title,//' Cover Details ',
        html: stHTML,
        type: "info",
        background: 'white',
        customClass: 'swal-wide !important',
        width: '50%',
        confirmButtonText: this.Translate.instant('Ok')
        // showCancelButton: true,
        // showConfirmButton:false
      });
    }
    catch{

    }

  }

  ValidateSpecialChar(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 67) || (k > 67 && k < 91) || (k > 96 && k < 99) || (k > 99 && k < 118) || (k > 118 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  uploadFile(fd) {
    var param = environment;              
    if (!param.St.StatusDesc) {
        throw new Error("Encryption key is not initialized.");
    }

    var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
    var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));

    this.isShowLoading = true;

    this.headers = new HttpHeaders();
    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.headers = this.headers.append('Accept-Encoding', 'gzip');
    this.headers = this.headers.append('apiToken', this.getToken());
    this.headers = this.headers.append("Authorization", "Basic " + btoa(UserName + ':' + Password));

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", fd, { headers: this.headers }).toPromise().then(
      function (res) {

      },
      function (res) {
        this.isShowLoading = false;
      });
    this.isShowLoading = false;
  }

  getToken(): string {
    let token: string = "";
    if (sessionStorage.getItem("token") != null) {
      token = sessionStorage.getItem("token");
    }
    return token;
  }

  OnSelectIDCopyFile(event) {
 
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      //this.objBindInfoRes.IDCopyName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.objBindInfoRes.IDCopyImage = null;
        swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "IDCopy");
      fd.append("attchmentId", this.objBindInfoRes.AttachmentId)

      this.uploadFile(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.objBindInfoRes.IDCopyImage = image.split(",")[1];
          this.objBindInfoRes.IDCopyExists = true;
          this.objBindInfoRes.IDCopyName = this.objBindInfoRes.AttachmentId+"_IDCopy"+fileExt;
        }


      }
    }
  }

  OnSelectIBANFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      //this.objBindInfoRes.IBANCopyName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";

      if (fsize > 2) {
        this.objBindInfoRes.IBANCopyImage = null;
        swal("File Size Should not exceed 2 MB"); return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "IBANCopy");
      fd.append("attchmentId", this.objBindInfoRes.AttachmentId);
      this.uploadFile(fd);
      reader.onload = (event) => {

        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.objBindInfoRes.IBANCopyImage = image.split(",")[1];
          this.objBindInfoRes.IBANCopyExists = true;
          this.objBindInfoRes.IBANCopyName = this.objBindInfoRes.AttachmentId+"_IBANCopy"+fileExt;
        }

      }
    }
  }


  OnSelectAltInsuranceFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.objBindInfoRes.AltInsuranceCopyName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";

      if (fsize > 2) {
        this.objBindInfoRes.AltInsuranceCopyImage = null;
        swal("File Size Should not exceed 2 MB"); return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "AltInsuranceCopy");
      fd.append("attchmentId", this.objBindInfoRes.AttachmentId);
      this.uploadFile(fd);
      reader.onload = (event) => {

        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.objBindInfoRes.AltInsuranceCopyImage = image.split(",")[1];
          this.objBindInfoRes.AltInsuranceCopyExists = true;
          this.objBindInfoRes.IDCopyName = this.objBindInfoRes.AttachmentId+"_AltInsuranceCopy"+fileExt;
        }

      }
    }
  }


  OnSelectNewOwnerIsthFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.objBindInfoRes.NewOwnerIsthCopyName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";

      if (fsize > 2) {
        this.objBindInfoRes.NewOwnerIsthCopyImage = null;
        swal("File Size Should not exceed 2 MB"); return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "NewOwnerCopy");
      fd.append("attchmentId", this.objBindInfoRes.AttachmentId);
      this.uploadFile(fd);
      reader.onload = (event) => {

        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.objBindInfoRes.NewOwnerIsthCopyImage = image.split(",")[1];
          this.objBindInfoRes.NewOwnerIsthCopyExists = true;
          this.objBindInfoRes.NewOwnerIsthCopyName = this.objBindInfoRes.AttachmentId+"_NewOwnerCopy"+fileExt;
        }

      }
    }
  }


  OnSelectVehDisposeCopyFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.objBindInfoRes.ProofOfVehDisposeCopyName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        swal("Please select valid image");
        return;
      }

      var isvalid = "";

      if (fsize > 2) {
        this.objBindInfoRes.NewOwnerIsthCopyImage = null;
        swal("File Size Should not exceed 2 MB"); return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "VehDisposeCopy");
      fd.append("attchmentId", this.objBindInfoRes.AttachmentId);
      this.uploadFile(fd);
      reader.onload = (event) => {

        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.objBindInfoRes.ProofOfVehDisposeCopyImage = image.split(",")[1];
          this.objBindInfoRes.ProofOfVehDisposeCopyExists = true;
          this.objBindInfoRes.ProofOfVehDisposeCopyName = this.objBindInfoRes.AttachmentId+"_VehDisposeCopy"+fileExt;
        }

      }
    }
  }




  CheckArabicCharactersOnly(e) {
    var unicode = e.charCode ? e.charCode : e.keyCode
    if (unicode != 8) { //if the key isn't the backspace key (which we should allow)
      if (unicode == 32)
        return true;
      else {
        if ((unicode < 48 || unicode > 57) && (unicode < 0x0600 || unicode > 0x06FF)) //if not a number or arabic
          return false; //disable key press
      }
    }


  }

  // KeyPressOrder(e) {

  //   var strCheck = 'ذض ص ث ق ف غ ع ه خ ح ج دش س ي ب ل ا ت ن م ك ط ئءؤرلاى ةوزظ';
  //   var whichCode = e.which ? e.which : e.keyCode;
  //   var key;
  //   if (whichCode == 13 || whichCode == 8 || whichCode == 9) return true;
  //   key = String.fromCharCode(whichCode);
  //   if (strCheck.indexOf(key) == -1){
     
  //     this.objBindInfoRes.InsuredName_Ar="";
  //     return false;
  //   }
  //   else
  //   {    return true;}
  // }



allowEnglishOnly(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode);
    const pattern = /^[A-Za-z ]+$/;
    if (!pattern.test(char)) {
      swal("Please Enter English Name only");
      event.preventDefault();
    }
  }


}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/Motor_Cancellation/Motor_Cancellation.ts